/**
 * Форма смены точки продаж для заявки
 */

import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { Select } from '@components/UI/FormItems';
import { useUpdatePointOfSale } from '@/hooks/useAdmin.ts';
import { useTerritorialDirections, usePointsOfSale } from '@/hooks/useReferences.ts';

interface UpdatePointOfSaleFormComponentProps {
  creditContractId: number | null;
}

/**
 * Компонент формы смены точки продаж
 */
export const UpdatePointOfSaleFormComponent: React.FC<UpdatePointOfSaleFormComponentProps> = ({
  creditContractId,
}) => {
  const [selectedTdId, setSelectedTdId] = useState<number | null>(null);
  const updatePointOfSaleMutation = useUpdatePointOfSale();
  const { data: territorialDirections = [] } = useTerritorialDirections();
  const { data: pointsOfSale = [] } = usePointsOfSale(selectedTdId || undefined);

  // Сбрасываем состояние при смене клиента
  React.useEffect(() => {
    setSelectedTdId(null);
  }, [creditContractId]);

  const handleTerritorialDirectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const tdId = parseInt(e.target.value, 10);
    setSelectedTdId(tdId || null);
  };

  const handlePointOfSaleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const posId = parseInt(e.target.value, 10);
    if (creditContractId && posId) {
      await updatePointOfSaleMutation.mutateAsync({
        creditContractId,
        pointOfSaleId: posId,
      });
    }
  };

  if (!creditContractId) {
    return null;
  }

  return (
    <fieldset>
      <Formik initialValues={{}} onSubmit={() => {}}>
        {() => (
          <Form>
            <div style={{ display: 'table' }}>
              <div style={{ marginLeft: '5px', fontWeight: 'bold' }}>
                Смена точки продаж для заявки по сделке
              </div>

              <Select
                label="Территориальная дирекция:"
                name="territorialDirection"
                onChange={handleTerritorialDirectionChange}
              >
                <option value={0}>Не выбрана</option>
                {territorialDirections.map((td) => (
                  <option key={td.id} value={td.id}>
                    {td.name}
                  </option>
                ))}
              </Select>

              {selectedTdId && (
                <Select
                  label="Точка продаж:"
                  name="pointOfSale"
                  onChange={handlePointOfSaleChange}
                  disabled={updatePointOfSaleMutation.isPending}
                >
                  <option value={0}>Не выбрана</option>
                  {pointsOfSale.map((pos) => (
                    <option key={pos.id} value={pos.id}>
                      {pos.shortName}
                    </option>
                  ))}
                </Select>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
